import React from 'react';
import { formatNumber } from '../../components/Common/Utilities';
import { loadTab, storeTab } from './StatusTabs';

// New UI for the Payment dashboard (docs/ui_redesign/14-screen-concepts.md, "Payment dashboard", option B): tabs by
// payment status over the same list, and the columns the page is for moved forward. Display only.

// The statuses apas_paymentdashboard_list returns.
export const PAYMENT_TABS = [
	{ key: 'all', label: 'All' },
	{ key: 'Unpaid', label: 'Unpaid' },
	{ key: 'Partially Paid', label: 'Partially Paid' },
	{ key: 'Fully Paid', label: 'Fully Paid' }
];
const TONE = { Unpaid: 'neutral', 'Partially Paid': 'warn', 'Fully Paid': 'ok' };

export function paymentTabs(rows) {
	const list = rows || [];
	return PAYMENT_TABS.map(t => ({ ...t, count: t.key === 'all' ? list.length : list.filter(r => r.paymentStatus === t.key).length }));
}
export const rowsForPayment = (rows, key) => (!key || key === 'all' || !Array.isArray(rows) ? rows : rows.filter(r => r.paymentStatus === key));

const TAB_KEY = m => `apworks.paymentTab.${m}`;
export const savedPaymentTab = m => loadTab(TAB_KEY(m), PAYMENT_TABS.map(t => t.key));
export const savePaymentTab = (m, key) => storeTab(TAB_KEY(m), key);

// Share of the amount paid, 0 to 1 (no bar when the amount is zero).
export function paidShare(row) {
	const a = Number(row && row.amount) || 0;
	const p = Number(row && row.paymentAmount) || 0;
	if (a <= 0) return null;
	return Math.max(0, Math.min(1, p / a));
}

function PaidCell({ row }) {
	const share = paidShare(row);
	const tone = TONE[row.paymentStatus] || 'neutral';
	return (
		<span className="apw2-paid" title={formatNumber(row.paymentAmount) + ' ' + (row.currencyCode || '')}>
			<span>{formatNumber(row.paymentAmount)}</span>
			{share != null ? <span className={'apw2-bar t-' + tone} aria-hidden="true"><i style={{ width: Math.round(share * 100) + '%' }} /></span> : null}
		</span>
	);
}

const ORDER = ['vendorName', 'invoiceNumber', 'invoiceDate', 'amount', 'paymentAmount', 'paymentStatus', 'paymentInfo', 'postedDate', 'ioNumber',
	'campaignName', 'mediaPlanName', 'jobCode', 'activityCode', 'approvedBy'];
const SIZE = {
	vendorName: [1.4, 170], invoiceNumber: [0.9, 116], invoiceDate: [0.8, 104], amount: [1, 128], paymentAmount: [1, 128], paymentStatus: [0.9, 136],
	paymentInfo: [0.8, 110], postedDate: [0.8, 96], ioNumber: [0.9, 116], campaignName: [1, 130], mediaPlanName: [1, 120], jobCode: [0.7, 90],
	activityCode: [0.8, 110], approvedBy: [1, 130]
};
const HEADER = { invoiceNumber: 'Invoice #', invoiceDate: 'Invoice date', paymentAmount: 'Paid', postedDate: 'Posted' };

export function arrangePaymentColumns(columns) {
	if (!Array.isArray(columns)) return columns;
	const rank = c => { const i = ORDER.indexOf(c.field); return i < 0 ? ORDER.length : i; };
	return columns.map((c, i) => [c, i]).sort((a, b) => (rank(a[0]) - rank(b[0])) || (a[1] - b[1])).map(([c]) => {
		if (!c || !SIZE[c.field]) return c;
		const [flex, minWidth] = SIZE[c.field];
		const out = { ...c, flex, minWidth, width: undefined, apw2Sized: true };
		if (HEADER[c.field]) out.headerName = HEADER[c.field];
		if (c.field === 'amount') out.renderCell = ({ row }) => <span className="apw2-num"><b className="apw2-amt">{formatNumber(row.amount)}</b><span className="apw2-ccy">{row.currencyCode || ''}</span></span>;
		if (c.field === 'paymentAmount') out.renderCell = ({ row }) => <PaidCell row={row} />;
		if (c.field === 'paymentStatus') out.renderCell = ({ value }) => (value ? <span className={'apw2-pill t-' + (TONE[value] || 'neutral')}>{value}</span> : '');
		return out;
	});
}
